// extracted by mini-css-extract-plugin
export default {"input":"addFileButton_input__7jCxt","file":"addFileButton_file__xFco+"};